module.exports = __webpack_public_path__ + "img/5.d12c12e3.svg";